// extracted by mini-css-extract-plugin
export default {"summary":"PatientSummaryCard_summary__dg0d+","eyebrow":"PatientSummaryCard_eyebrow__eURmm","tiles":"PatientSummaryCard_tiles__xCc71"};